import { initDevices } from "./init";
import { thunkSpreader } from "../../../utils/helpers";
import * as thunks from "./thunks";

const thunkEnum = thunkSpreader(thunks);

export const extraReducers = {
  [initDevices.pending]: (state, action) => {
    state.init.status = "loading";
  },
  [initDevices.fulfilled]: (state, action) => {
    return {
      ...state,
      init: {
        status: "success",
      },
      ...action.payload,
    };
  },
  [initDevices.rejected]: (state, action) => {
    return {
      ...state,
      init: {
        status: "error",
      },
    };
  },
  ...thunkEnum,
};
